import { FC } from 'react';
import { ListItem, ListItemProps } from '@chakra-ui/react';

/**
 * Item container for OBList
 */
const Item: FC<ListItemProps> = ({ children, ...props }) => (
  <ListItem
    display="grid"
    gridGap="space-16"
    gridTemplateColumns="24px 1fr"
    {...props}
  >
    {children}
  </ListItem>
);

export default Item;
